module.exports = __webpack_public_path__ + "static/media/item-on.92e76819.svg";